<template>
  <div class="class-detail-module">
    <el-dialog :title="`班级详情【${detail.skuName}】`" :visible.sync="dialogVisible" fullscreen :before-close="handleClose">
      <el-tabs v-model="index" tab-position="left">
        <el-tab-pane label="包含基础必学课程" name="1">
          <Course v-if="index === '1'" :id="detail.id" :type="1" />
        </el-tab-pane>
        <template v-if="detail.courseType === 2">
          <el-tab-pane label="包含职业方向课程" name="2">
            <Course v-if="index === '2'" :id="detail.id" :type="2" />
          </el-tab-pane>
          <el-tab-pane label="包含实操课程" name="3">
            <Course v-if="index === '3'" :id="detail.id" :type="3" />
          </el-tab-pane>
        </template>
        <el-tab-pane label="班级学员管理" name="4">
          <StudentsManagefrom v-if="index === '4'" :skuId="detail.id"/>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer" />
    </el-dialog>
  </div>
</template>

<script>
import Course from './classCourse.vue'
import StudentsManagefrom from './studentsManage.vue';

export default {
  name: 'ClassDetail',

  components: { Course, StudentsManagefrom },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      index: '1',
      dialogVisible: false
    }
  },
  methods: {
    handleClose () {
      this.index = null
      this.dialogVisible = false
    }
  },
}
</script>

<style>

</style>
